export const notNullOrUndefined = ([, value]: [string, string]) =>
    value !== undefined && value !== null;
